import { useSelector } from "react-redux";

import { assert, rootNodeDesignerNodeDataOrNullSelector } from "@skilitics/nautilus-core-designer-data";

// NOTE: this will only fire once per module but we don't expect to swap out the root node!
export const useRootNodeData = () => {
  const node = useSelector(rootNodeDesignerNodeDataOrNullSelector);
  assert(node, "Root node data is not available");
  return node;
};
